import { forwardRef } from 'react';

import type { DialogComboboxTriggerProps } from '../DialogCombobox';
import { DialogComboboxTrigger } from '../DialogCombobox';

export interface SelectV2TriggerProps extends DialogComboboxTriggerProps {}

export const SelectV2Trigger = forwardRef<HTMLButtonElement, SelectV2TriggerProps>((props, ref) => {
  const { children, ...restProps } = props;
  return (
    <DialogComboboxTrigger allowClear={false} {...restProps} ref={ref}>
      {children}
    </DialogComboboxTrigger>
  );
});
